import axios from 'axios';

export const getUnits = async ()=>{
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.REACT_APP_URL_API}/units`)
      .then(res=>resolve(res))
      .catch(err => reject(err));
  });
}